import React, { useState, useEffect } from "react";
import '../../css/ContentBox.css';

export default function ContentBox({
  children
}) {
  return (
    <div className="content-container"> 
      <div className="content-box" style={{position: 'relative'}}> 
        {children}
      </div>
    </div>
  );
}
